import { Box, Typography, makeStyles } from '@material-ui/core'
import BellIcon from 'assets/images/bell-icon.svg'
import { IProduct } from 'interfaces/IProduct'


interface IAlertWeighinsProps {
  product: IProduct
}

const useStyles = makeStyles({
  root: {
    display: 'flex',
    width: '100%',
    backgroundColor: '#DFEAFF',
    padding: '0.6rem 0.6rem 0.6rem 1rem',
    borderRadius: '16px',
    alignItems: 'center',
    color: '#2E75FF',
    gap: '1rem',
    fontWeight: 500,
    marginTop: '1rem',
  },
})

const AlertWeighinsNoScanner = (props: IAlertWeighinsProps) => {
  const { product} = props
  const classes = useStyles()

  const isUnity = product.unity_product_base === 'unidade'

  return !isUnity ? (
    <Box className={classes.root}>
      <img src={BellIcon} />{' '}
      <Typography>
          Separe {product.quantity} pacotes de{' '}
          {product.purchase_value}
          {product.type === 'peso' ? 'kg' : 'un'} do produto
      </Typography>
    </Box>
  ) : null
}

export default AlertWeighinsNoScanner
